import React, { Component } from 'react'
import { Table, message, Button, Input } from 'antd'
import request from "@/method/request";
import "./index.scss"

export default class index extends Component {
    state = {
        data: [],
        dataAll: [],
        name: "",
        selectedRowKeys: [],
        id: ''
    }
    componentDidMount() {
        this.getData();
    }

    getData = async () => {
        try {
            const res = await request('/getHotels');
            const saveRes = await request('/api/getBpSave');
            this.setState({
                id: saveRes.data.id,
                data: res.data.hotels || [],
                dataAll: res.data.hotels || [],
                selectedRowKeys: (saveRes.data.hotels || '').split(',').map(x => ~~x)
            })
        } catch (error) {
            message.error('获取列表失败！');
            console.error(error);
        }
    }

    onSearch = () => {
        const { name, dataAll } = this.state;
        const names = (name || "").split(" ").filter(x => x);
        const data = dataAll.filter(x => {
            let _name = (x.name || "").trim().toUpperCase();
            let code = (x.code || "").trim().toUpperCase();
            let area = (x.area || "").trim().toUpperCase();
            return names.some(v => _name.includes(v.toUpperCase()) || code.includes(v.toUpperCase()) || area.includes(v.toUpperCase()))
        });
        this.setState({ data })
    }
    onSave = async () => {
        try {
            let headres = {
                method: 'post',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify({ data: { id: this.state.id, hotels: this.state.selectedRowKeys.join() } })
            }
            const res = await request('/api/saveBpSave', headres);
            if (res.status == 1) message.info('保存成功！');
        } catch (error) {
            message.error('获取列表失败！');
            console.error(error);
        }

    }
    render() {
        const { data, selectedRowKeys, name, dataAll } = this.state;
        const columns = [
            {
                title: '序号',
                dataIndex: 'id',
                key: 'id',
            },
            {
                title: '酒店名称',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '千乘code',
                dataIndex: 'code',
                key: 'code',
            },
        ];

        return (
            <div className="bp-save">
                <div className="top-search">
                    <div className="item">
                        <span className="name">关联字</span>
                        <Input value={name}
                            onPressEnter={this.onSearch}
                            onChange={e => {
                                this.setState({
                                    name: e.target.value
                                })
                            }} placeholder="请输入关键字,多个关联字用空格分开" />
                    </div>
                    <Button type="primary" onClick={this.onSearch}>搜索</Button>
                </div>
                <div className='row'>
                    <Button type="primary" onClick={() => {
                        this.setState({
                            selectedRowKeys: dataAll.map(x => x.id)
                        })
                    }}>全选</Button>
                    <Button type="primary" onClick={() => {
                        this.setState({
                            selectedRowKeys: dataAll.filter(x => !selectedRowKeys.includes(x.id)).map(x => x.id)
                        })
                    }}>反选</Button>
                </div>
                <Table
                    rowSelection={{
                        selectedRowKeys,
                        type: "checkbox",
                        onChange: (selectedRowKeys, selectedRows) => {
                            this.setState({ selectedRowKeys });
                        },
                    }}
                    rowKey={r => r.id}
                    columns={columns}
                    dataSource={data}
                />
                <div className="bottom-btn">
                    <Button type="primary" onClick={this.onSave}>保存</Button>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/setting/BpSave/index.js